export const walletAppConfig = {
  appId: import.meta.env.VITE_WORLD_APP_ID ?? '',
  bubbleGameAppId: import.meta.env.VITE_BUBBLETEAWORLD_APP_ID ?? '',
  worldIdRpId: import.meta.env.VITE_WORLD_ID_RP_ID ?? '',
  worldIdAction: import.meta.env.VITE_WORLD_ID_ACTION ?? 'dailyclaim',
  bubbleClaimContractAddress: import.meta.env.VITE_BUBBLE_CLAIM_CONTRACT_ADDRESS ?? '',
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL ?? '',
  publishableKey: import.meta.env.VITE_GG_PUBLISHABLE_KEY ?? '',
  centralAuthIssuerUrl: import.meta.env.VITE_CENTRAL_AUTH_ISSUER_URL ?? '',
  centralAuthClientId: import.meta.env.VITE_CENTRAL_AUTH_CLIENT_ID ?? '',
  centralAuthRedirectUri: import.meta.env.VITE_CENTRAL_AUTH_REDIRECT_URI ?? '',
  flight404FirebaseApiKey: import.meta.env.VITE_FLIGHT404_FIREBASE_API_KEY ?? '',
  flight404FirebaseProjectId: import.meta.env.VITE_FLIGHT404_FIREBASE_PROJECT_ID ?? 'flight404-firebase',
  flight404FirebaseFunctionsBaseUrl: import.meta.env.VITE_FLIGHT404_FIREBASE_FUNCTIONS_BASE_URL
    ?? 'https://asia-southeast1-flight404-firebase.cloudfunctions.net',
} as const;

export const isConfiguredWorldAppId = (appId: string): boolean =>
  /^app_[a-zA-Z0-9]+$/.test(appId);

export const walletAppDeepLink = isConfiguredWorldAppId(walletAppConfig.appId)
  ? `https://world.org/mini-app?app_id=${walletAppConfig.appId}&path=${encodeURIComponent('/')}`
  : null;

export const bubbleGameFurnaceDeepLink = isConfiguredWorldAppId(walletAppConfig.bubbleGameAppId)
  ? `https://world.org/mini-app?app_id=${walletAppConfig.bubbleGameAppId}&path=${encodeURIComponent('/furnace')}`
  : null;

export const bubbleGameDeepLink = isConfiguredWorldAppId(walletAppConfig.bubbleGameAppId)
  ? `https://world.org/mini-app?app_id=${walletAppConfig.bubbleGameAppId}&path=${encodeURIComponent('/')}`
  : null;
